module.exports = __webpack_public_path__ + "assets/img/modile-logo-orange.737662a5.svg";